export const convertBlobURLToFile = async (blob) => {
  const r = await fetch(blob.media);
  const blobFile = await r.blob();
  return new File([blobFile], blob.filename, {
    type: blob.content_type,
    lastModified: blob.lastModified,
  });
};
